import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chat",
  "use": "chat-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"chat\"><path d=\"M12 4v8H2v17l4.3-3H20v-8h5.7l4.3 3V4zm6 20H5.7L4 25.13V14h14zm10-6.87L26.3 16H20v-2h4v-2H14V6h14z\" /><path d=\"M6 16h10v2H6zM6 20h8v2H6zM16 8h10v2H16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/chat.svg
// module id = OO+m
// module chunks = 39 44